import { render, staticRenderFns } from "./AlreadyBoughtCourse.vue?vue&type=template&id=0b7d1325&scoped=true"
import script from "./AlreadyBoughtCourse.vue?vue&type=script&lang=js"
export * from "./AlreadyBoughtCourse.vue?vue&type=script&lang=js"
import style0 from "./AlreadyBoughtCourse.vue?vue&type=style&index=0&id=0b7d1325&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7d1325",
  null
  
)

export default component.exports